import { z } from 'zod';

/**
 * Common enums and schemas shared across domain entities
 * This file breaks circular dependencies between users.ts and subscriptions.ts
 */

/**
 * Notification channel enum - used by both users and subscriptions
 */
export enum NotificationChannel {
  Telegram = 'telegram',
  Email = 'email',
  WhatsApp = 'whatsapp',
}

/**
 * Notification channel schema
 */
export const NotificationChannelSchema = z.nativeEnum(NotificationChannel);

/**
 * Language level enum - used by users
 */
export enum LanguageLevel {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2',
}

/**
 * Learning view enum - used by users
 */
export enum LearningView {
  TELEGRAM = 'telegram',
  WEB = 'web',
}

/**
 * Subscription plan enum - used by subscriptions and users
 */
export enum SubscriptionPlan {
  Free = 'free',
  Pro = 'pro',
  Ultra = 'ultra',
}

/**
 * Subscription status enum - used by subscriptions and users
 */
export enum SubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Trialing = 'trialing',
  PastDue = 'past_due',
}

/**
 * Language level schema
 */
export const LanguageLevelSchema = z.nativeEnum(LanguageLevel);

/**
 * Learning view schema
 */
export const LearningViewSchema = z.nativeEnum(LearningView);

/**
 * Subscription plan schema
 */
export const SubscriptionPlanSchema = z.nativeEnum(SubscriptionPlan);

/**
 * Subscription status schema
 */
export const SubscriptionStatusSchema = z.nativeEnum(SubscriptionStatus);
